// Constants for Works Council Application

export const BusinessUnitEnum = {
  DEFENCE_AND_SECURITY: "Defence and Security (D&S)",
  ENVIRONMENT_AND_SUSTAINABILITY: "Environment and Sustainability (E&S)", 
  GENERAL_AND_ADMINISTRATIVE: "General and Administrative (G&A)",
  HIGH_TECH_CONSULTING: "High-tech Consulting (HTC)",
  SPACE_AND_SCIENCE: "Space and Science (S&S)"
};

export const BusinessUnits = [
  BusinessUnitEnum.DEFENCE_AND_SECURITY,
  BusinessUnitEnum.ENVIRONMENT_AND_SUSTAINABILITY,
  BusinessUnitEnum.GENERAL_AND_ADMINISTRATIVE,
  BusinessUnitEnum.HIGH_TECH_CONSULTING,
  BusinessUnitEnum.SPACE_AND_SCIENCE
];

// Election Status Constants
export const ElectionStatus = {
  UPCOMING: 'upcoming',
  NOMINATION: 'nomination',
  VOTING: 'voting',
  COMPLETED: 'completed'
};

// User Roles
export const UserRoles = {
  USER: 'user',
  ADMIN: 'admin'
};
